import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";
export const TABLE_COLUMNS = [
  {
    Header: "No Color Included",
    accessor: "noColorIncluded",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "No Location Included",
    accessor: "noLocIncluded",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Pricing Type",
    accessor: "pricingType",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
